import { h } from '@stencil/core';
import { SUBCATEGORY, tryParse } from '@pes-ui/utils';
export class CategoryRangeList {
  constructor() {
    this.subcategoryId = undefined;
    this.hostWithLocale = undefined;
    this.ranges = undefined;
    this.subCatagoryProductRangeLabel = undefined;
    this.viewOnLabel = undefined;
    this.rangePartofLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.avoidAccents = undefined;
    this._ranges = undefined;
    this._subCatagoryProductRangeLabel = undefined;
    this._viewOnLabel = undefined;
    this._rangePartofLabel = undefined;
    this._rangeProductsViewDetailsLabel = undefined;
    this._productRelationsViewProdLabel = undefined;
    this._avoidAccents = undefined;
    this.storageName = '';
    this.currentPageStorageKey = undefined;
    this.host.dir = document.documentElement.dir || 'auto';
  }
  async componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g;
    this.ranges = (_a = tryParse(this._ranges)) !== null && _a !== void 0 ? _a : this.ranges;
    this.subCatagoryProductRangeLabel = (_b = tryParse(this._subCatagoryProductRangeLabel)) !== null && _b !== void 0 ? _b : this.subCatagoryProductRangeLabel;
    this.viewOnLabel = (_c = tryParse(this._viewOnLabel)) !== null && _c !== void 0 ? _c : this.viewOnLabel;
    this.rangePartofLabel = (_d = tryParse(this._rangePartofLabel)) !== null && _d !== void 0 ? _d : this.rangePartofLabel;
    this.rangeProductsViewDetailsLabel = (_e = tryParse(this._rangeProductsViewDetailsLabel)) !== null && _e !== void 0 ? _e : this.rangeProductsViewDetailsLabel;
    this.productRelationsViewProdLabel = (_f = tryParse(this._productRelationsViewProdLabel)) !== null && _f !== void 0 ? _f : this.productRelationsViewProdLabel;
    this.avoidAccents = (_g = tryParse(this._avoidAccents)) !== null && _g !== void 0 ? _g : this.avoidAccents;
    const subcategoryId = this.subcategoryId || this.host.parentElement.getAttribute('subcategoryId');
    this.currentPageStorageKey = `${SUBCATEGORY}/${subcategoryId}`;
  }
  render() {
    return (h("section", null, h("qds-title", { class: "range-list__title", layer: "main", level: "section", tag: "h1", alignment: "start" }, this.subCatagoryProductRangeLabel), h("ul", { class: "range-list" }, this.ranges
      && this.ranges.map((range, id) => (h("li", { class: "range-list__item" }, h("pes-category-range-card", { class: "range-card", data: range, currentPageStorageKey: this.currentPageStorageKey, storageName: this.hostWithLocale, subcategoryView: true, rangePartofLabel: this.rangePartofLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: this.rangeProductsViewDetailsLabel, avoidAccents: this.avoidAccents, withImageLazy: id > 3 })))))));
  }
  static get is() { return "pes-category-range-list"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["category-range-list.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["category-range-list.css"]
    };
  }
  static get properties() {
    return {
      "subcategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "4040"
            }],
          "text": "The ID of the subcategory."
        },
        "attribute": "subcategory-id",
        "reflect": false
      },
      "hostWithLocale": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hostWithLocale contains host, countryCode and languageCode"
        },
        "attribute": "host-with-locale",
        "reflect": false
      },
      "ranges": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TRange[]",
          "resolved": "TRange[]",
          "references": {
            "TRange": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "list of ranges"
        }
      },
      "subCatagoryProductRangeLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for subcategory product list"
        },
        "attribute": "sub-catagory-product-range-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View on #domain_name#\""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "rangePartofLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"Part of #MasterRangeName#\""
        },
        "attribute": "range-partof-label",
        "reflect": false
      },
      "rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View details\""
        },
        "attribute": "range-products-view-details-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "label for \"View products\""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "avoidAccents": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Styling title and description of range-card"
        },
        "attribute": "avoid-accents",
        "reflect": false
      },
      "_ranges": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-ranges",
        "reflect": false
      },
      "_subCatagoryProductRangeLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-sub-catagory-product-range-label",
        "reflect": false
      },
      "_viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view-on-label",
        "reflect": false
      },
      "_rangePartofLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-partof-label",
        "reflect": false
      },
      "_rangeProductsViewDetailsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-products-view-details-label",
        "reflect": false
      },
      "_productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-relations-view-prod-label",
        "reflect": false
      },
      "_avoidAccents": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-avoid-accents",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "storageName": {},
      "currentPageStorageKey": {}
    };
  }
  static get elementRef() { return "host"; }
}
